export const SETTASKSLIST = "SETTASKSLIST";
export const SETTASKSTATUSLIST = "SETTASKSTATUSLIST";
export const SETEMPLOYEELIST = "SETEMPLOYEELIST";
export const SETSUPERUSER = "SETSUPERUSER";
export const SETTASK = "SETTASK";
export const SETATTACHMENTDATA = "SETATTACHMENTDATA";
export const SETTASKLISTBYID = "SETTASKLISTBYID";
export const SETTASKCOUNT = "SETTASKCOUNT";
export const SETCOMMENTSLISTDATA = "SETCOMMENTSLISTDATA";
